export const categoryColors = {
  'meditation': {
    border: 'border-purple-500',
    text: 'text-purple-500',
    bg: 'bg-purple-100 dark:bg-purple-900/30'
  },
  'sutra': {
    border: 'border-orange-500',
    text: 'text-orange-500',
    bg: 'bg-orange-100 dark:bg-orange-900/30'
  },
  'philosophy': {
    border: 'border-blue-500',
    text: 'text-blue-500',
    bg: 'bg-blue-100 dark:bg-blue-900/30'
  },
  'practice': {
    border: 'border-green-500',
    text: 'text-green-500',
    bg: 'bg-green-100 dark:bg-green-900/30'
  },
  'history': {
    border: 'border-red-500',
    text: 'text-red-500',
    bg: 'bg-red-100 dark:bg-red-900/30'
  },
  default: {
    border: 'border-primary',
    text: 'text-primary',
    bg: 'bg-primary/10'
  }
} as const;

export type CategoryKey = keyof typeof categoryColors;

export const getCategoryColors = (category: string) => {
  const key = category.toLowerCase() as CategoryKey;
  return categoryColors[key] || categoryColors.default;
}; 